import React from 'react';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  actions?: React.ReactNode;
  decorationEmoji?: string;
}

export default function PageHeader({ title, subtitle, eyebrow, actions, decorationEmoji }: PageHeaderProps) {
  return (
    <div className="page-header">
      <div className="page-header-inner container">
        {eyebrow && <p className="page-header-eyebrow text-label">{eyebrow}</p>}
        <div className="page-header-content">
          <div>
            <h1 className="page-header-title text-headline">
              {decorationEmoji && <span className="page-header-emoji" aria-hidden="true">{decorationEmoji}</span>}
              {title}
            </h1>
            {subtitle && <p className="page-header-subtitle text-subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="page-header-actions">{actions}</div>}
        </div>
        <div className="page-header-rule" aria-hidden="true">
          <LeafDivider />
        </div>
      </div>
    </div>
  );
}

function LeafDivider() {
  return (
    <svg viewBox="0 0 600 16" xmlns="http://www.w3.org/2000/svg" className="leaf-divider" aria-hidden="true" preserveAspectRatio="none">
      <line x1="0" y1="8" x2="240" y2="8" stroke="var(--parchment-dark)" strokeWidth="1"/>
      <g transform="translate(300,8)">
        <ellipse cx="-20" cy="0" rx="14" ry="6" fill="var(--sage-pale)" transform="rotate(-20)"/>
        <ellipse cx="0" cy="-2" rx="12" ry="5" fill="var(--sage-light)" opacity="0.6"/>
        <ellipse cx="20" cy="0" rx="14" ry="6" fill="var(--sage-pale)" transform="rotate(20)"/>
      </g>
      <line x1="360" y1="8" x2="600" y2="8" stroke="var(--parchment-dark)" strokeWidth="1"/>
    </svg>
  );
}
